import { LayoutGrid, Tags } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const segmentationNavigation: NavItem[] = [
  {
    to: '/segmentation',
    labelKey: 'nav.segmentation',
    group: 'nav.groups.registry',
    icon: Tags,
    permission: 'users.view',
  },
  {
    to: '/app-modules',
    labelKey: 'nav.appModules',
    group: 'nav.groups.registry',
    icon: LayoutGrid,
    permission: 'users.view',
  },
]
